// graphql server
import { ApolloClient, InMemoryCache, createHttpLink, from, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

import secureLocalStorage from 'react-secure-storage';
import handleErrors from './GQL_ERROR_HANDLE';

// ----------------------------------------------------------------------

const URI = process.env.NODE_ENV === 'development' ? 'http://localhost:4000/graphql' : '/graphql';

const httpLink = createHttpLink({
  uri: URI
  // credentials: 'include'
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: process.env.NODE_ENV === 'development' ? 'ws://localhost:4000/subscribe' : '/subscribe'
  })
);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = secureLocalStorage.getItem('token');

  // return the headers to the context so httpLink can read them
  // include adminInfo in development mode to avoid login every time
  if (process.env.NODE_ENV === 'development') {
    return {
      headers: {
        ...headers,
        authorization: token ?? '',
        admininfo: localStorage.getItem('admin-info') ?? '{}'
      }
    };
  }
  return {
    headers: {
      ...headers,
      authorization: token ?? ''
    }
  };
});

const errorLink = onError((errors) => {
  handleErrors(errors);
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  httpLink
);

const defaultOptions = {
  watchQuery: {
    // fetchPolicy: 'no-cache',
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore'
  },
  query: {
    // fetchPolicy: 'no-cache',
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  }
};

const client = new ApolloClient({
  cache: new InMemoryCache({
    addTypename: false,
    typePolicies: {
      Query: {
        fields: {
          UALogsWithLatLongbyTime: {
            // Don't cache separate results based on any of this field's arguments.
            // If needed, keyArgs: []
            keyArgs: false,

            // Concatenate the incoming list items with
            // the existing list items.
            merge(existing = { LENGTH: 0, UALogs: [], MORE: true }, incoming) {
              // console.log('existing', existing);
              // console.log('incoming', incoming);
              return {
                LENGTH: existing.LENGTH + incoming.LENGTH,
                UALogs: [...existing.UALogs, ...incoming.UALogs],
                MORE: incoming.MORE
              };
            }
          }
        }
      }
    }
  }),
  link: from([errorLink, authLink, splitLink]),
  defaultOptions
});
export default client;
